import { z } from 'zod';
import { ApprovalVerdictSchema } from '../../entities/approval';
import { GetApprovalResponseSchema } from '../get-approval/get-approval.schema';
/**
 * Decide Approval
 * POST /api/v2/approval/:id/decide — a named reviewer's word, once. A
 * rejection needs a reason, which the requester reads.
 */ export const DecideApprovalRequestSchema = z.object({
    verdict: ApprovalVerdictSchema,
    comment: z.string().max(2000).default('')
});
export const DecideApprovalResponseSchema = GetApprovalResponseSchema;

//# sourceMappingURL=decide-approval.schema.js.map